import React from "react";
import Loader from "@components/Loader";
import { Link } from "react-router-dom";
import CategoriesFilter from "@components/catalog/CategoriesFilter";
import CategoriesTable from "@components/catalog/CategoriesTable";
import { useCategoriesQuery } from "@queries/catalog";
import "@styles/opencart-admin.css";

export default function CategoriesPage() {
  const [filters, setFilters] = React.useState({});
  const [page, setPage] = React.useState(1);
  const pageSize = 50;

  const { data, isLoading, isError, error, isFetching } = useCategoriesQuery(filters, page, pageSize);

  const tree = data?.data || [];
  const total = data?.meta?.total ?? 0;
  const pages = Math.max(1, Math.ceil((data?.meta?.total_roots ?? 1) / pageSize));

  return (
    <div className="oc-content">
      {(isLoading || isFetching) && <Loader />}

      <div className="oc-header">
        <h1>Categories</h1>
        <nav className="oc-bc">
          <span>Home</span><span className="sep">›</span><span>Catalog</span><span className="sep">›</span><span>Categories</span>
        </nav>
      </div>

      <div className="oc-card oc-filter">
        <div className="title">Filter</div>
        <CategoriesFilter
          value={filters}
          onChange={(f) => { setPage(1); setFilters(f); }}
        />
      </div>

      {isError && (
        <div className="oc-card" style={{ color: "#c00" }}>
          Error: {error.message}
        </div>
      )}

      <div className="oc-card">
        <div className="oc-toolbar">
          <div><strong>Category List</strong></div>

        <div className="oc-header-actions"> <Link to="/catalog/categories/new" className="oc-btn"> + New Category </Link> </div>


        </div>
        <CategoriesTable tree={tree} />
      </div>

      <div className="oc-card" style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <div>
          Showing page <strong>{page}</strong> of <strong>{pages}</strong> ({total} total)
        </div>
        <div style={{ display:"flex", gap:8 }}>
          <button className="oc-btn ghost" disabled={page<=1} onClick={()=>setPage(1)}>« First</button>
          <button className="oc-btn ghost" disabled={page<=1} onClick={()=>setPage(p=>p-1)}>‹ Prev</button>
          <button className="oc-btn ghost" disabled={page>=pages} onClick={()=>setPage(p=>p+1)}>Next ›</button>
          <button className="oc-btn ghost" disabled={page>=pages} onClick={()=>setPage(pages)}>Last »</button>
        </div>
      </div>
    </div>
  );
}

